import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import MultiSelect from './MultiSelect';
import { getCompanyType } from '../../redux/partnerProfileSlice';

const FilterPanelPartnerProfile = ({ onFilter, onReset, className }) => {
  const dispatch = useDispatch();
  const companyTypes = useSelector(state => state.partnerProfile.companyType)|| []// Adjust according to your state structure
  const countriesOptions = [
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "China", label: "China" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Korea", label: "Korea" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Turkey", label: "Turkey" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Rest of World", label: "Rest of World" },
  ];

  const [searchValue, setSearchValue] = useState('');
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [companyTypeId, setCompanyTypeId] = useState('');

  useEffect(() => {
    const queryParams = {
        type: 'partner'
      };
    dispatch(getCompanyType(queryParams));
  }, [dispatch]);

  const handleSearchChange = (e) => setSearchValue(e.target.value);
  const handleCountriesChange = (selectedItems) => setSelectedCountries(selectedItems);
  const handleCompanyTypeChange = (e) => setCompanyTypeId(e.target.value);

  const handleFilter = () => {
    onFilter({
      search: searchValue,
      countries: selectedCountries,
      companyTypeId,
    });
  };

  const handleReset = () => {
    setSearchValue('');
    setSelectedCountries([]);
    setCompanyTypeId('');
    onReset();
  };
  return (
    <div className={className}>
      <div className="card">
        <div className="card-body">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                label="Search"
                variant="outlined"
                value={searchValue}
                onChange={handleSearchChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} md={4}>
              {/* Assuming MultiSelect is properly implemented to handle multiple selections */}
              <MultiSelect
                options={countriesOptions}
                label="Select Countries"
                onChange={handleCountriesChange}
                value={selectedCountries}
                multiple
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="company-type-label">Company Type</InputLabel>
                <Select
                  labelId="company-type-label"
                  value={companyTypeId}
                  onChange={handleCompanyTypeChange}
                  label="Company Type"
                >
                    <MenuItem value="" disabled>
                          Select Company Type
                        </MenuItem>
                  {companyTypes.map((type) => (
                    <MenuItem key={type.companyTypeName} value={type.companyTypeName}>
                      {type.companyTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item container spacing={1} className="mt-2">
              <Grid item xs={1}>
                <button
                  className="btn btn-primary greeen-btn md_btn"
                  onClick={handleFilter}
                >
                  <span>
                    <FilterAltOutlinedIcon />
                  </span>
                  Filter
                </button>
              </Grid>
              <Grid item >
                <button
                  className="btn btn-light grey-btn md_btn "
                  onClick={handleReset}
                >
                  <span>
                    <i className="bi bi-funnel"></i>Reset
                  </span>
                  
                </button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default FilterPanelPartnerProfile;
